import React from "react";
import "../styles/navbar.css";
import logo from "../assets/images/logo.png";

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg sky-navbar">
      <div className="container">

        {/* Logo */}
        <a className="navbar-brand" href="/">
          <img src={logo} alt="Sky Terminal" className="logo" />
        </a>

        {/* Mobile Toggle */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
        >
          <i className="fa-solid fa-bars text-white"></i>
        </button>

        <div
          className="collapse navbar-collapse"
          id="navbarContent"
        >
          {/* Center Menu */}
          <ul className="navbar-nav mx-auto">
            <li className="nav-item">
              <a className="nav-link" href="#about">
                About
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="#how-it-works">
                How It Works
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="#tokenomic">
                Tokenomic
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="#roadmap">
                Roadmap
              </a>
            </li>
          </ul>

          {/* Right Icons */}
          <div className="d-flex align-items-center gap-2 social-icons">

            <a
              href="https://t.me/skyterminal_news"
              target="_blank"
              rel="noreferrer"
              className="social-circle"
            >
              <i className="fa-solid fa-paper-plane"></i>
            </a>

            <a
              href="https://x.com/skyterminal_io"
              target="_blank"
              rel="noreferrer"
              className="social-circle"
            >
              <i className="fa-brands fa-x-twitter"></i>
            </a>

            <a
              href="https://medium.com/@skyterminal"
              target="_blank"
              rel="noreferrer"
              className="social-circle"
            >
              <i className="fa-brands fa-medium-m"></i>
            </a>

          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;